import useABTestV2 from '@/utils/abtest/useABTestV2'
import { ISSUE_403_PAYMENT_FLOW_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import GTM from '@/utils/tracking/gtm'
import BrowserStorage from '@/utils/BrowserStorage'

type ABGroup = 'A' | 'B' | ''

type ABTestResult = {
  isAPattern: boolean
  isBPattern: boolean
}

interface PaymentFlowABTest {
  initialize: () => void
  abGroup: ComputedRef<ABGroup>
  sendOnSiteAccess: () => void
  sendOnEventDetailPageClick: () => void
  sendOnPaymentPageClick: () => void
  sendOnTicketClickInModal: () => void
}

const SITE_ACCESS_GA_SENT_KEY = 'issue403_site_access_ga_sent'

export function usePaymentFlowABTest(): PaymentFlowABTest {
  const abTestResult = useState<ABTestResult | null>('payment-flow-ab-test', () => null)

  const initialize = () => {
    if (abTestResult.value === null) {
      abTestResult.value = useABTestV2(ISSUE_403_PAYMENT_FLOW_AB_TEST_CONFIG)
    }
  }

  const abGroup = computed<ABGroup>(() => {
    if (abTestResult.value === null) return ''
    if (abTestResult.value.isAPattern) return 'A'
    if (abTestResult.value.isBPattern) return 'B'
    return ''
  })

  const isActive = computed(() => abGroup.value !== '')

  const sendOnSiteAccess = () => {
    if (!isActive.value) return

    if (import.meta.server) return

    const sessionStorage = new BrowserStorage('sessionStorage')

    if (sessionStorage.getItem(SITE_ACCESS_GA_SENT_KEY)) {
      return
    }

    GTM.sendEventToGa({
      category: 'issue403',
      action: 'view',
      label: abGroup.value
    })

    sessionStorage.setItem(SITE_ACCESS_GA_SENT_KEY, 'true')
  }

  const sendOnEventDetailPageClick = () => {
    if (!isActive.value) return
    GTM.sendEventToGa({
      category: 'issue403',
      action: 'click',
      label: `${abGroup.value}、遷移先（詳細）`
    })
  }

  const sendOnPaymentPageClick = () => {
    if (!isActive.value) return
    GTM.sendEventToGa({
      category: 'issue403',
      action: 'click',
      label: `${abGroup.value}、遷移先（購入方法選択ページ）`
    })
  }

  const sendOnTicketClickInModal = () => {
    if (!isActive.value) return
    GTM.sendEventToGa({
      category: 'issue403',
      action: 'click',
      label: 'A、遷移先（決済登録選択画面）'
    })
  }

  return {
    initialize,
    abGroup,
    sendOnSiteAccess,
    sendOnEventDetailPageClick,
    sendOnPaymentPageClick,
    sendOnTicketClickInModal
  }
}
